import React from 'react';

import { Button } from '../../common/button';
import ConfirmDialog from './confirm_dialog';

const BlockerReturnButton = ({ formik, onReturn }) => (
    formik.dirty ? (
        <ConfirmDialog
            buttonText="Wróć"
            isLoading={ false }
            title="Masz niezapisane zmiany"
            subtitle="Czy na pewno chcesz opuścić tę stronę? Niezapisane dane zostaną utracone."
            cancelText="Zostań"
            primaryAction={ () => onReturn() }
            primaryText="Opuść bez zapisu"
            displayIcon={ false }
        />
    ) : (
        <Button variant="outlined" onClick={ () => onReturn() }>
            Wróć
        </Button>
    )
);

export default BlockerReturnButton;